import React from "react"
import { connect } from "react-redux"
import classNames from "classnames"
import {
  toggleFirstPartSidebarAction,
  toggleSecondPartSidebarAction,
  toggleSidebarProcessingParametersAction
} from "../../state/application/actions"

import FormContainer from "./search-form-sidebar/SearchFormSidebar"
import SearchResults from "./search-results-sidebar/SearchResultsSidebar"
import SearchResultDetailsContainer from "./search-result-details-sidebar/SearchResultDetailsSidebar"
import {
  getSearchFormValuesByState,
} from "../../helpers/configurationHelper";
import {
  isSearchResultsSidebarToggleVisibleByState,
  isSearchSidebarToggleVisibleByState,
  SEARCH_RESULTS_SIDEBAR_TITLE,
  SEARCH_SIDEBAR_TITLE
} from "../../helpers/sidebarsHelper";
import {formatCompactNumber} from "../../helpers/utilsHelper";
import {
  AllInterferometricStacksType,
  ProductImageStacType,
  SearchResultElementType,
  SearchResultsType
} from "../../types/product";
import {ConfigurationsType} from "../../types/configurations";
import {ShapeType} from "../../types/shape";
import translations from "../../translations";

interface PropsType {
  configurations: ConfigurationsType,
  isSearchResultDetailsShown: boolean,
  toggleFirstPartSidebarActionHandler: any,
  toggleSecondPartSidebarActionHandler: any,
  toggleSidebarProcessingParametersActionHandler: any,
  searchResults: SearchResultsType,
  searchResultDetails: SearchResultElementType,
  width: number,
  background: string,
  searchFormValues: any,
  selectedProducts: ProductImageStacType[],
  isSearchSidebarToggleVisible: boolean,
  isSearchResultsSidebarToggleVisible: boolean,
  isProcessingParametersSidebarToggleVisible: boolean,
  processFiltersSelected: any,
  selectedArea: ShapeType,
  allInterferometricStacks: AllInterferometricStacksType,
  language: string
}

const SideBar = (props: PropsType) => {
  const {
    configurations,
    isSearchResultDetailsShown,
    toggleFirstPartSidebarActionHandler,
    toggleSecondPartSidebarActionHandler,
    toggleSidebarProcessingParametersActionHandler,
    searchResults,
    searchResultDetails,
    width,
    background,
    searchFormValues,
    selectedProducts,
    isSearchSidebarToggleVisible,
    isSearchResultsSidebarToggleVisible,
    isProcessingParametersSidebarToggleVisible,
    processFiltersSelected,
    selectedArea,
    allInterferometricStacks,
    language
  } = props;
  const sidebarWidth = width;
  const sidebarBackgroundColor = background;
  const isFirstButtonVisible = isSearchSidebarToggleVisible;
  const isSecondButtonVisible = isFirstButtonVisible && isSearchResultsSidebarToggleVisible;
  const isThirdButtonVisible = isSecondButtonVisible && isProcessingParametersSidebarToggleVisible && Object.keys(processFiltersSelected).length > 0;

  return (
    <>
      <div className="sidebar-toggle-btn-wrapper">

        <button
          className={classNames("sidebar-toggle-btn remove-btn-defaults", {
            "d-none": !isFirstButtonVisible
          })}
          type="button"
          onClick={() => toggleFirstPartSidebarActionHandler(true)}
        >
          <span>{translations(SEARCH_SIDEBAR_TITLE, language)}</span>
          <svg><use xlinkHref="#right_arrow-icon" fill="#9A9BA6" /></svg>
        </button>

        <button
          className={classNames("sidebar-toggle-btn second remove-btn-defaults", {
            "d-none": !isSecondButtonVisible
          })}
          type="button"
          onClick={() => toggleSecondPartSidebarActionHandler(true)}
        >
          <span className="quantity">{(searchResults && formatCompactNumber(searchResults.totalItems)) || 0}</span>
          <span>{translations(SEARCH_RESULTS_SIDEBAR_TITLE, language)}</span>
          <svg><use xlinkHref="#right_arrow-icon" fill="#9A9BA6" /></svg>
        </button>

        <button
          className={classNames("sidebar-toggle-btn second remove-btn-defaults", {
            "d-none": !isThirdButtonVisible
          })}
          type="button"
          onClick={() => toggleSidebarProcessingParametersActionHandler(true)}
        >
          <svg><use xlinkHref="#right_arrow-icon" fill="#9A9BA6" /></svg>
        </button>

      </div>

      <div className="side-bar" style={{backgroundColor: sidebarBackgroundColor || "transparent", width: sidebarWidth}}>
        <FormContainer />

        <SearchResults />

        {(isSearchResultDetailsShown && searchResultDetails) ? <SearchResultDetailsContainer /> : null}
      </div>
    </>
  )
};

const mapStateToProps = (state) => ({
  configurations: state.application.configurations,
  selectedArea: state.geoMap.lastShape,
  isSearchResultDetailsShown: state.application.isSearchResultDetailsShown,
  searchResults: state.product.searchResults,
  searchResultDetails: state.application.searchResultDetails,
  processFiltersSelected: state.application.processFiltersSelected,
  selectedProducts: state.product.selectedProducts,
  searchFormValues: getSearchFormValuesByState(state),
  isSearchSidebarToggleVisible: isSearchSidebarToggleVisibleByState(state),
  isSearchResultsSidebarToggleVisible: isSearchResultsSidebarToggleVisibleByState(state),
  allInterferometricStacks: state.product.allInterferometricStacks,
  language: state.application.appParameters.language
});

const mapDispatchToProps = (dispatch) => ({
  toggleFirstPartSidebarActionHandler: (e) => dispatch(toggleFirstPartSidebarAction(e)),
  toggleSecondPartSidebarActionHandler: (e) => dispatch(toggleSecondPartSidebarAction(e)),
  toggleSidebarProcessingParametersActionHandler: (e) => dispatch(toggleSidebarProcessingParametersAction(e)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SideBar)
